import React from 'react';

import {OEFNWelcomeEntryTypes} from '../../views/flow-nav/welcome/oe-fn-welcome-model';
import OEProtoStartView, {OEProtoStartViewEntryTypes} from '../oe-proto-start-view';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OESurgeryTargetType, OESurgeryTargets, OESurgeryFeatureAccess, OESurgeryStartSelectionData} from './oe-surgery-model';
import {OEFlowNavModalFlags} from '../../views/flow-nav/oe-flow-nav-modal';

export default class OESurgeryStartView extends React.PureComponent {

    constructor(props) {
        super(props);

        let modules = OESurgeryStartSelectionData.chooseModules();

        let targetTypeEntries = [
            {type: OEProtoStartViewEntryTypes.targetType, targetType: OESurgeryTargetType.anatomy, stringId: 'start_view_title_anatomy', icon: OEIconCodes.surgery.anatomyTarget},
            {type: OEProtoStartViewEntryTypes.targetType, targetType: OESurgeryTargetType.approachOp, stringId: 'start_view_title_approach_op', icon: OEIconCodes.surgery.approachOpTarget},
            {type: OEProtoStartViewEntryTypes.targetType, targetType: OESurgeryTargetType.ophthalmology, stringId: 'start_view_title_ophthalmology', icon: OEIconCodes.surgery.ophthalmologyTarget},
            {type: OEProtoStartViewEntryTypes.targetType, targetType: OESurgeryTargetType.orthoOp, stringId: 'start_view_title_ortho_op', icon: OEIconCodes.surgery.orthoOpTarget},
        ].filter(entry => modules.findIndex(module => module.id === entry.targetType) >= 0);

        this.entries = [
            {type: OEFNWelcomeEntryTypes.maskBlock, mask: {licenseValid: true}, entries: [
                {type: OEFNWelcomeEntryTypes.spacer, height: '3.375em' /*54*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_text', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_module_selection', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/},
                ...targetTypeEntries,
                {type: OEFNWelcomeEntryTypes.spacer, height: '2em' /*32*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_help_target_note', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/}
            ]},
            {type: OEFNWelcomeEntryTypes.maskBlock, mask: {licenseValid: false}, entries: [
                {type: OEFNWelcomeEntryTypes.spacer, height: '4.625em' /*74*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_text_no_license', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/},
                {type: OEFNWelcomeEntryTypes.licensing},
                {type: OEFNWelcomeEntryTypes.spacer, height: '2.25em' /*36*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_module_selection_no_license', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/},
                {type: OEProtoStartViewEntryTypes.demo, targetType: OESurgeryTargetType.approachOp, stringId: 'start_view_title_approach_op', icon: OEIconCodes.surgery.approachOpTarget},
                {type: OEFNWelcomeEntryTypes.spacer, height: '2.125em' /*34*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_help_target_note', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/}
            ]},
            {type: OEFNWelcomeEntryTypes.help, stringId: 'welcome_view_help_target_menu', className: 'help-entry', flowNavModalFlags: OEFlowNavModalFlags.closeOnToggle},
            {type: OEFNWelcomeEntryTypes.spacer, height: '1.5em' /*24*/}
        ];
    }

    render()    {
        return (
            <OEProtoStartView
                {...this.props}
                entries={this.entries}
                versionTargets={OESurgeryTargets}
                featureAccess={OESurgeryFeatureAccess}
                startSelectionData={OESurgeryStartSelectionData}
            />
        );
    }
}